export default "__VITE_ASSET__JL7NFLdc__"